import { Component, OnInit } from '@angular/core';
import { CouponSearchDto } from '../shared/dto/coupon-search.dto';

@Component({
  selector: 'wl-coupon-search',
  templateUrl: './coupon-search.component.html',
  styleUrls: ['./coupon-search.component.less'],
    standalone: false
})
export class CouponSearchComponent implements OnInit {
  searchParams: CouponSearchDto;

  constructor() {
    this.searchParams = new CouponSearchDto();
  }

  ngOnInit(): void {}
}
